<template>
    <div>
        <div class="card mb-4" v-for="station in stations" :key="station.station_id">
            <div class="card-body">
                <h4 class="card-title">{{ station.name }}</h4>
                <h5 class="card-subtitle text-muted mt-2" style="opacity: 0.8;">
                    <span class="mdi mdi-google-maps"></span>{{ formatAddress(station) }}
                </h5>

                <button class="btn btn-success pull-right mt-2" disabled>
                    Manage &raquo;
                </button>
            </div>
        </div>
    </div>
</template>

<script>
    import { StationService } from '../../services/stationService'

    export default {
        data() {
            return {
                viewState: 'Busy',
                stations: []
            }
        },
        async mounted() {
            try {
                this.stations = await StationService.getStations()
                console.log(this.stations)
                this.viewState = 'Idle'
            } catch (error) {
                this.viewState = 'Error'
                console.error(error)
            }
        },
        methods: {
            formatAddress(station) {
                let addr1 = station.address1 ? `${station.address1}` : ''
                let addr2 = station.address2 ? `${station.address2}` : ''
                let addr3 = station.address3 ? `${station.address3}` : ''
                let city = station.city ? `${station.city}` : ''
                let country = station.country ? `${station.country}` : ''

                return `${addr1}${addr1 ? ', ' : ''}${addr2}${addr2 ? ', ' : ''}${addr3}${addr3 ? ', ' : ''}${city}${city ? ', ' : ''}${country}`
            }
        }
    }
</script>